export const auth = {
  login: {
    title: 'Login',
    subtitle: 'Access your Travail Global account',
    candidate: 'Candidate',
    employer: 'Employer',
    email: 'Email address',
    password: 'Password',
    remember: 'Remember me',
    forgot: 'Forgot password?',
    submit: 'Login',
    loading: 'Logging in...',
    error: 'Invalid credentials or server error.',
    noAccount: 'Don\'t have an account?',
    register: 'Sign up',
    welcomeTitle: 'Welcome to Travail Global',
    welcomeSubtitle: 'Find the best career opportunities all over the world.'
  },
  register: {
    candidateTitle: 'Candidate Registration',
    candidateSubtitle: 'Find the best opportunities',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    terms: 'I accept the',
    termsLink: 'terms of use',
    submit: 'Register',
    loading: 'Registering...',
    hasAccount: 'Already have an account?',
    login: 'Login here',
    welcomeTitle: 'Join our network',
    welcomeSubtitle: 'Create your profile and apply to the best offers.'
  }
};
